import React from 'react'
import { Card, Button, Empty, Tag } from "antd-mobile";
import { useNavigate } from 'react-router-dom';


export default function GameListContainer(props) {

    const navigate = useNavigate()

    const { gameList } = props;

    const resultData = () => (
        (gameList && gameList.length > 0) ?
            gameList.map((game) => (
                <Card
                    key={game.id}
                    title={
                        <div style={{ fontWeight: '600' }}>
                            {game.status === 0 ? <Tag color='danger'>待开赛</Tag> :
                                game.status === 1 ? <Tag color='warning'>分队中</Tag> :
                                    game.status === 2 ? <Tag color='primary'>比赛中</Tag> :
                                        game.status === 3 ? <Tag>已结束</Tag> :
                                            game.status === 4 ? <Tag fill='outline'>已取消</Tag> : null
                            }
                            &nbsp;
                            {game.startDate}&nbsp;
                            {game.gameName}
                        </div>
                    }
                    style={{
                        borderRadius: '12px', margin: '4px', border: '1px solid #DCDCDC'
                    }}
                >
                    <div>
                        <span>地址:{game.address}</span>
                        <br />
                        <span>时间:{game.startDate + '(' + game.week + ')'}</span>
                        <br />
                        {game.status === 3 ?
                            <span>{'比分 ' + game.greenGoal + ':' + game.redGoal}</span> : null
                        }
                    </div>
                    <div onClick={e => e.stopPropagation()} style={{
                        paddingTop: '11px',
                        borderTop: '1px solid #e5e5e5',
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}>
                        {game.status === 4 ? null :
                            <Button
                                color='primary'
                                size='small'
                                onClick={() => {
                                    if (game.status === 0) {
                                        navigate(`/games/${game.id}/signup`);
                                    } else
                                        if (game.status === 1) {
                                            navigate(`/games/${game.id}/ready`);
                                        } else
                                            if (game.status === 2) {
                                                navigate(`/games/${game.id}/live`);
                                            } else
                                                if (game.status === 3) {
                                                    navigate(`/games/${game.id}/history`);
                                                }
                                }}
                            >
                                查看详情
                            </Button>
                        }
                    </div>
                </Card>
            ))
            : <Empty description='暂无数据' style={{ height: '80vh' }} />
    )

    return (
        <div>
            {resultData()}
        </div>
    )
}
